import React from 'react';
import PhototherapyApp from '../phototherapy/PhototherapyApp';
import { BILI2022_VARIANT } from '../phototherapy/variants';

/**
 * "צהבת ביילוד AAP 2022" — the same jaundice calculator as צהבת ביילוד, with its
 * own configuration and AAP 2022 as the protocol a hospital gets by default.
 *
 * All behaviour lives in `../phototherapy/PhototherapyApp.tsx`; this app only
 * binds the `BILI2022` variant. See `../phototherapy/variants.ts`.
 */
export const Bili2022: React.FC<{ hospital?: string }> = ({ hospital }) => (
  <PhototherapyApp hospital={hospital} variant={BILI2022_VARIANT} />
);

export default Bili2022;
